export default "<div class=\"sw-settings-country-preview-template\">\n    <div v-html=\"displayFormattingAddress\"></div>\n</div>\n";